import { useState } from "react";
import { GameModes } from "../../../config";
import { allowsDemo, formatGameName } from "../../../utils";
import PragmaticGameCard from "./pragmaticLiveGameCard";

export const GameCard = ({
  alias,
  imagePath,
  game,
  gameName,
  isVirtual,
  provider,
  onPlay,
}) => {
  const [showActions, setShowActions] = useState(false);

  const handleCardClick = (e) => {
    // Prevent bubbling if clicking on buttons
    if (e.target.tagName === "BUTTON") return;
    setShowActions(!showActions);
  };
  if (provider === "pragmaticlive") {
    return <PragmaticGameCard gameData={game} onPlay={onPlay} />;
  }
  return (
    <div
      className="relative aspect-[3/2] rounded-lg overflow-hidden shadow-lg cursor-pointer transition-transform duration-300 hover:scale-105"
      onClick={handleCardClick}
    >
      {/* Game image as background */}
      <img
        src={imagePath}
        alt={gameName || alias}
        className="object-cover w-full h-full rounded-lg"
      />

      {/* Game name strip/bar at the bottom */}
      <div className="absolute bottom-0 left-0 right-0 bg-black/80 py-2 px-3">
        <h3 className="text-white font-medium text-sm text-center truncate">
          {formatGameName(gameName || alias)}
        </h3>
      </div>

      {/* Overlay that shows on hover (desktop) or click (mobile) */}
      <div
        className={`absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent
                    flex flex-col items-center justify-end p-3 sm:p-4 transition-all duration-300
                    ${
                      showActions
                        ? "opacity-100"
                        : "opacity-0 md:hover:opacity-100"
                    }`}
      >
        {/* Action buttons container */}
        <div className="flex flex-col gap-2 sm:gap-3 w-full max-w-full">
          {/* Demo button */}
          {allowsDemo(provider) && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onPlay(GameModes.DEMO);
              }}
              className="bg-white text-gray-800 font-medium 
                        py-2 px-4 sm:px-6 
                        rounded-md sm:rounded-lg
                        hover:bg-gray-100 active:bg-gray-200 
                        transition-all shadow-md hover:shadow-lg 
                        text-xs sm:text-sm md:text-base uppercase tracking-wide
                        focus:outline-none focus:ring-2 focus:ring-gray-300
                        w-full flex items-center justify-center"
            >
              Demo
            </button>
          )}

          {/* Play button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              onPlay(GameModes.REAL);
            }}
            className="bg-buttonGradient text-white font-medium 
                        py-2 px-4 sm:px-6 
                        rounded-md sm:rounded-lg
                        hover:from-blue-600 hover:to-purple-700 
                        active:from-blue-700 active:to-purple-800
                        transition-all shadow-md hover:shadow-lg 
                        text-xs sm:text-sm md:text-base uppercase tracking-wide
                        focus:outline-none focus:ring-2 focus:ring-purple-400
                        w-full flex items-center justify-center"
          >
            Play
          </button>
        </div>

        {/* Provider name (optional) */}
        {/* {provider && (
            <p className="text-gray-300 text-xs mt-2 sm:mt-3 font-medium opacity-80">
              {provider}
            </p>
          )} */}
      </div>
    </div>
  );
};
